import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'

import type { Lang } from './types'
import TranslationFactory from './translations/factory'
import { setI18nForAuth } from './aws-amplify'
import config from '../../config'

/**
 * Include here all paths where i18n content is returned
 * They will be refetch when the language is changed.
 */
export const API_PATH_I18N_SUPPORTED = ['/videos', '/documents', '/categories']

/**
 * Configure static content i18n
 */
i18n
  .use(initReactI18next)
  .init({
    fallbackLng: 'es',
    debug: config.DEV,
    interpolation: { escapeValue: false },
    resources: {
      es: { translation: TranslationFactory.getTranslation('es').getDictionary() },
      en: { translation: TranslationFactory.getTranslation('en').getDictionary() },
    }
  })

const setI18n = (lang: Lang) => {
  setI18nForApp(lang)
  setI18nForAuth(lang)
}

/**
 * Our app uses i18next as i18n provider.
 * We set here all keys and their translations for all languages we support
 * @param lang currentLanguage
 */
const setI18nForApp = (lang: Lang) => {
  i18n.changeLanguage(lang)
}

/**
 * Languages supported
 */
export const languages = [{ code: 'es', label: 'Español' }, { code: 'en', label: 'English' }]


/**
 * Change current language
 * @param lang
 */
export const changeLanguage = (lang: Lang) => {
  document.cookie = `lang=${lang};path=/;max-age=31536000;SameSite=Lax`
  setI18n(lang)
}

/**
 * Set default lang from cookies or 'es'
 */
const lang = document.cookie.split('; ').find(row => row.startsWith('lang='))
const defaultLang = lang ? lang.split('=')[1] : 'es'
setI18n(defaultLang as Lang)


export default i18n
